import type { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useTimeSlotSelectFilterStyles = makeStyles((theme: Theme) => ({
    button: {
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
    input: {
        fontSize: 12,
        marginTop: 2,
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        cursor: "pointer",
        width: 150,
    },
    radioGroupContainer: {
        paddingLeft: "16px",
        paddingTop: "7px",
    },
    timePickersContainer: {
        display: "flex",
        margin: "auto 16px 8px 16px",
        position: "relative",
    },
    disabledStyle: {
        opacity: 0.5,
    },
    timePicker: {
        minWidth: "71px",
    },
    timePickersSpacer: {
        display: "flex",
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        justifyContent: "center",
        alignItems: "center",
    },
    textSize: {
        fontSize: 14,
    },
}));
